import React from "react";
import PropTypes from "prop-types";
import { Modal } from "@ann/web-components";

const DuplicateModal = ({ isOpen, onClose, onDuplicate, triggerName }) => {
  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="small"
      closeFromOutside={true}
    >
      <Modal.Header icon>
        <Modal.Header.Title>Duplicate this workflow?</Modal.Header.Title>
        <Modal.Header.Description>
          A copy of {triggerName} will be created.
        </Modal.Header.Description>
        <Modal.Header.Description>
          You can edit the copy without affecting the original.
        </Modal.Header.Description>
      </Modal.Header>
      <Modal.Body></Modal.Body>
      <Modal.Actions align="center">
        <Modal.Button label="Cancel" onClick={onClose} type="secondary" />
        <Modal.Button
          label="Duplicate"
          onClick={() => {
            onDuplicate();
            onClose();
          }}
          type="primary"
        />
      </Modal.Actions>
    </Modal>
  );
};

DuplicateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired,
  triggerName: PropTypes.string,
};

export default DuplicateModal;
